import React from 'react'
import Nav from "../../Components/Nav/Nav.jsx";
import Header from './Header.jsx';

const Medicine = () => {
  return (
    <div>
    <Nav title="HEALTHसखा" />
    <Header/>

        
    </div>

  )
}

export default Medicine